import { ZyConsoleIcon } from '@/components/tiptap-editor/tiptap-icons/zyconsole-icon';
import { forwardRef } from 'react';
import { GenericExtensionButton, type GenericExtensionButtonProps } from '../generic-extension-button';

export const ZyConsoleButton = forwardRef<
    HTMLButtonElement,
    Omit<GenericExtensionButtonProps, 'extensionName' | 'extensionType' | 'icon' | 'label' | 'command'>
>((props, ref) => (
    <GenericExtensionButton
        extensionName="zyConsole"
        extensionType="node"
        icon={ZyConsoleIcon}
        label="Insert zyConsole"
        command={editor => editor.commands.insertZyConsole()}
        ref={ref}
        {...props}
    />
));

ZyConsoleButton.displayName = 'ZyConsoleButton';

export default ZyConsoleButton;
